import {format as dateFormat, parse as dateParse} from 'date-fns';
import DifferenceFormatter from 'humanize-duration-es6';
import differenceFormatterLocaleEn from 'humanize-duration-es6/dist/locale/en';
import startCase from 'lodash.startcase';
import numeral from 'numeral';
import Vue from 'vue';

const formatter = new DifferenceFormatter(differenceFormatterLocaleEn);

Vue.filter('number_format', (value, format = '0,000.[00000]') => numeral(value || 0).format(format));
Vue.filter('percent_format', (value, format = '0,000.[00]') => `${numeral((value || 0) * 100).format(format)}%`);
Vue.filter('money_format', (value, format = '$0,000.00') => numeral(value || 0).format(format));
Vue.filter('date_format', (value, format = 'Do MMM YYYY') => dateFormat(dateParse(value), format));
Vue.filter('datetime_format', (value, format = 'Do MMM YYYY [at] hh:mma') => dateFormat(dateParse(value), format));
Vue.filter('time_format', (value, format = 'hh:mma') => dateFormat(dateParse(value), format));
Vue.filter('minute_format', value => formatter.humanize(value * 60000));
Vue.filter('second_format', value => formatter.humanize(value * 1000));
Vue.filter('millisecond_format', value => formatter.humanize(value));
Vue.filter('title_format', startCase);
